(() => {
  const SELECTOR = '[data-video-sound-toggle]';

  const getVideo = (button) => {
    const scope = button.closest('deferred-media') || button.closest('.video-section');
    if (!scope) return null;
    const videos = Array.from(scope.querySelectorAll('video'));
    if (videos.length <= 1) return videos[0] || null;
    // A single deferred-media can hold desktop + mobile variants; control the visible one.
    return videos.find((video) => video.offsetParent !== null) || videos[0];
  };

  const sync = (button, video) => {
    button.classList.toggle('is-muted', video.muted);
    button.setAttribute('aria-pressed', String(!video.muted));
    button.setAttribute('aria-label', button.dataset[video.muted ? 'labelUnmute' : 'labelMute']);
  };

  const toggle = (button) => {
    const video = getVideo(button);
    if (!video) return;
    video.muted = !video.muted;
    if (!video.muted) {
      const played = video.play();
      if (played && typeof played.catch === 'function') played.catch(() => {});
    }
    sync(button, video);
  };

  const init = () => {
    document.querySelectorAll(SELECTOR).forEach((button) => {
      if (button.dataset.soundBound) return;
      button.dataset.soundBound = 'true';
      const video = getVideo(button);
      if (!video) return;
      sync(button, video);
      button.addEventListener('click', () => toggle(button));
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
